<template>
  <div class="home">
    <template v-if="!isAuthenticated">
      <span>Bitte anmelden, um die Applikation zu verwenden.</span>
    </template>

    <template v-else>
      <RouterNavCard />
    </template>
  </div>
</template>
<script setup lang="ts">
  import RouterNavCard from "@/components/RouterNavCard.vue";
  import { onMounted } from "vue";
  import { useIsAuthenticated } from "@/composition-api/useIsAuthenticated";
  import { useBackendApi } from "@/composition-api/useBackendApi";
  import { useToast } from "primevue/usetoast";

  const isAuthenticated = useIsAuthenticated();
  const apis = useBackendApi();
  const toast = useToast();

  onMounted(() => {
    apis.callWhenTokenInitialized(() => {
      if (!isAuthenticated.value) return;
      void doPing();
    });
  });

  async function doPing() {
    try {
      await apis.boostrack.ping();
    } catch (error) {
      toast.add({
        severity: "error",
        summary: "Fehler",
        detail: "Keine Verbindung zum Ausgabeautomat.",
        life: 5000,
      });
      console.error("Error pinging backend:", error);
    }
  }
</script>
